import React from 'react'
import {useLocation} from 'react-router-dom'
import {getCurrentBaseAppPath} from '../apps'
import {getRouterConfig} from '../config'
import {concatPath, firstSegment as firstSegmentOfRoute} from '../helpers'
import {isModuleExists, modulesList, useLoadAllModules} from '../modules'
import Routes from './Routes'
import LoadingIndicator from './LoadingIndicator'

const loadedAppsList: any[] = []

const loadedModulesList: any[] = []

export default function Render() {
  const location = useLocation()

  // To Load All providers in runtime ::Disabled it
  // const { isLoaded } = useLoadAllModules()
  //
  // console.log(isLoaded, 'isLoaded')

  const [loadedModules, loadModules] = React.useState<any[]>([])

  let firstSegment = firstSegmentOfRoute(location)

  const currentBaseAppPath = getCurrentBaseAppPath()

  firstSegment = concatPath(currentBaseAppPath, firstSegment)

  const moduleIsLoaded = loadedModules.includes(firstSegment)

  React.useEffect(() => {
    // Get current module info by the first segment
    const moduleInfo = modulesList[firstSegment]

    if (!moduleIsLoaded && moduleInfo) {
      const modulePaths = []

      // load main provider app
      moduleInfo.loadApp && modulePaths.push(moduleInfo.loadApp())

      // load module provider m
      moduleInfo.loadModule && modulePaths.push(moduleInfo.loadModule())

      Promise.all(modulePaths).then(() => {
        if (!loadedAppsList.includes(moduleInfo.app)) {
          loadedAppsList.push(moduleInfo.app)
        }

        if (!loadedModulesList.includes(moduleInfo.module)) {
          loadedModulesList.push(moduleInfo.module)
        }

        moduleInfo.entry && loadModules(loadedModules.concat(moduleInfo.entry))
      })
    }
  }, [firstSegment, loadedModules, moduleIsLoaded])

  if (!moduleIsLoaded && isModuleExists(firstSegment)) {
    const Preloader: React.FunctionComponent = getRouterConfig('preloader', LoadingIndicator)

    return <Preloader />
  }

  return <Routes />
}
